import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsBehavior = lazy(() =>
	import('@/features/air/case-management/components/details/behavior/details-behavior').then(
		(m) => ({ default: m.DetailsBehavior }),
	),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/behavior',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Behavior · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<ErrorBoundary feature="case-management" section="behavior" entityId={id}>
			<Suspense fallback={<Skeleton className="h-96 w-full" />}>
				<DetailsBehavior id={id} />
			</Suspense>
		</ErrorBoundary>
	)
}
